var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { components } from 'react-select';
import classNames from 'classnames';
import '../../css/clydePillSelect.css';
export var Option = function (props) {
    var _checkboxClass = classNames('clyde-pill-select-option-checkbox', {
        'clyde-pill-select-option-checkbox--checked': props.isSelected,
        'clyde-pill-select-option-checkbox--disabled': props.isDisabled,
    });
    var _checkboxSpanClass = props.isDisabled
        ? 'clyde-pill-select-option-label--disabled' : 'clyde-pill-select-option-label';
    return (React.createElement("div", null,
        React.createElement(components.Option, __assign({}, props),
            React.createElement("label", { className: _checkboxClass }),
            React.createElement("input", { type: 'checkbox', checked: props.isSelected, onChange: function () { return null; }, className: 'clyde-pill-select-option-input' }),
            React.createElement("span", { className: _checkboxSpanClass }, props.label))));
};
export var DropdownIndicator = function (props) { return (React.createElement(components.DropdownIndicator, __assign({}, props),
    React.createElement("div", { className: 'clyde-pill-select-arrow' }))); };
export var MultiValueContainer = function (props) { return React.createElement(React.Fragment, null, props.data.value !== 'selectAll' && React.createElement(components.MultiValueContainer, __assign({}, props))); };
